export const tabNames = [
  'Hasil Kerja Utama',
  'Hasil Kerja Tambahan',
  'Perilaku Kerja',
  'Pengajuan',
]

export const tabNamesSubmitted = [
  'Hasil Kerja Utama',
  'Hasil Kerja Tambahan',
  'Perilaku Kerja',
]

export const reviewTabNames = [
  'Hasil Kerja Utama',
  'Hasil Kerja Tambahan',
  'Perilaku Kerja',
  'Persetujuan',
]

export const tabNamesV2 = [
  'Praktik Pembelajaran',
  'Pengembangan Kompetensi',
  'Tugas Tambahan',
  'Perilaku Kerja',
  'Rangkuman',
]

export const buktiKaryaCategoryMappings = [
  {
    key: 'ARTIKEL',
    iconName: 'newspaper',
    title: 'Artikel',
  },
  {
    key: 'MATERI_AJAR',
    iconName: 'text_snippet',
    title: 'Materi Ajar',
  },
  {
    key: 'BAHAN_AJAR',
    iconName: 'text_snippet',
    title: 'Bahan Ajar',
  },
  {
    key: 'DOKUMEN_TEKNIS',
    iconName: 'addchart',
    title: 'Dokumen Teknis',
  },
  {
    key: 'KEPEMIMPINAN_SEKOLAH',
    iconName: 'groups',
    title: 'Kepemimpinan Sekolah',
  },
  {
    key: 'PRAKTIK_PEMBELAJARAN',
    iconName: 'book',
    title: 'Praktik Pembelajaran',
  },
  {
    key: 'PRAKTIK_BAIK',
    iconName: 'playlist_add_check',
    title: 'Praktik Baik',
  },
  {
    key: 'RPP',
    iconName: 'list',
    title: 'RPP/Modul Ajar',
  },
  {
    key: 'KARYA_LAINNYA',
    iconName: 'web',
    title: 'Karya Lainnya',
  },
  {
    key: 'KARYA_LAINNYA',
    iconName: 'web',
    title: 'Lainnya',
  },
]
